import React from "react";

const SearchBox = ({ styleName, placeholder, onChange, value, onKeyPress }) => {

  return (
    <div className={`gx-search-bar ${styleName}`} style={{ width: '100%' }}>
      <div className="gx-form-group">
        <input className="ant-input" type="search" placeholder={placeholder} onChange={onChange} onKeyPress={onKeyPress}
          value={value} style={{ width: '100%' }} />
        <span className="gx-search-icon gx-pointer"><i className="icon icon-search" /></span>
      </div>
    </div>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
